import { CN, WIDTH, DISPLAY } from './constants'

const cn = (cn) => ({
	type: CN,
	cn,
})

const width = (width) => ({
	type: WIDTH,
	width,
})

const display = (display) => ({
	type: DISPLAY,
	display,
})

export const reset = (show) => {
	return (dispatch) => {
		dispatch(cn('fast-preloader hide-preloader'))
		dispatch(width(0))

		if (!show) {
			setTimeout(() => {
				dispatch(preloader())
			}, 50)
		}
	}
}

export const preloader = () => {
	return (dispatch, getState) => {
		// let currentWidth = getState().preloader.width
		let currentWidth = 0

		if (currentWidth === 0) {
			dispatch(cn(''))
			dispatch(width(90))
		} else {
			dispatch(width(100))
			dispatch(cn('fast-preloader'))

			setTimeout(() => {
				currentWidth = getState().preloader.width

				if (currentWidth === 100) {
					dispatch(cn('fast-preloader hide-preloader'))
					dispatch(width(0))
				}
			}, 400)
		}
	}
}
